var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
export function getClassifierIdsByNamesAsync(classifier, names, errors, getErrorMessage) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!names.length) {
            return undefined;
        }
        const uniqueNames = [...new Set(names)];
        const result = yield new StorageClient(classifier).list({
            filter: [{ column: 'name', op: 'in', value: uniqueNames }],
        });
        const nameToIdMap = {};
        result.rows.forEach(({ id, columns }) => {
            nameToIdMap[columns.name] = id;
        });
        if (result.rows.length !== uniqueNames.length) {
            uniqueNames.forEach((name) => {
                if (!nameToIdMap[name]) {
                    errors.push(getErrorMessage(name));
                }
            });
            return undefined;
        }
        return Object.values(nameToIdMap);
    });
}
